import Reveal from "@/components/Reveal";
import { OctagonPause, SprayCan, ShieldCheck } from "lucide-react";

const steps = [
  {
    n: "٠١",
    en: "STOP",
    ar: "أوقف الانتشار",
    icon: OctagonPause,
    text: "نظّف الظفر وجفّفه جيداً — بيئة جافة تعني بيئة غير مرحّبة بالفطريات.",
  },
  {
    n: "٠٢",
    en: "CURE",
    ar: "عالج بعمق",
    icon: SprayCan,
    text: "رشّ يوكيور مباشرة على الظفر وحوله، مرة إلى مرتين يومياً، ودع التركيبة تجف.",
  },
  {
    n: "٠٣",
    en: "CARE",
    ar: "احمِ النموّ",
    icon: ShieldCheck,
    text: "واظب على الطقس يومياً لتساند نموّ ظفر صحي المظهر وتمنع عودة المشكلة.",
  },
];

export default function Ritual() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-20 sm:px-6 lg:py-28">
      <Reveal>
        <p className="text-sm font-bold tracking-[0.3em] text-[#2E9E6B]">طقوس العناية اليومية</p>
        <h2 className="font-display mt-3 text-2xl font-black text-[#0F1E19] sm:text-3xl lg:text-4xl">
          ثلاث خطوات، أقل من دقيقة
        </h2>
        <p className="mt-2 text-sm font-bold tracking-[0.25em] text-[#D4AF37]" dir="ltr">
          STOP · CURE · CARE
        </p>
      </Reveal>

      <div className="relative mt-14 grid gap-10 md:grid-cols-3">
        <div
          className="absolute inset-x-16 top-8 hidden border-t-2 border-dashed border-[#2E9E6B]/30 md:block"
          aria-hidden="true"
        />
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div className="group relative text-center" data-testid={`ritual-step-${i + 1}`}>
              <div className="relative mx-auto flex h-16 w-16 items-center justify-center rounded-2xl border border-[#2E9E6B]/25 bg-white shadow-sm transition-all duration-500 group-hover:-translate-y-1.5 group-hover:border-[#2E9E6B] group-hover:shadow-lg group-hover:shadow-emerald-900/10">
                <s.icon className="h-7 w-7 text-[#1F7A52]" />
                <span className="absolute -top-3 -right-3 flex h-7 w-7 items-center justify-center rounded-full bg-[#0F1E19] text-xs font-black text-[#D4AF37]">
                  {s.n}
                </span>
              </div>
              <p className="mt-5 text-[11px] font-black tracking-[0.35em] text-[#2E9E6B]" dir="ltr">
                {s.en}
              </p>
              <h3 className="font-display mt-1 text-xl font-black text-[#0F1E19]">{s.ar}</h3>
              <p className="mx-auto mt-2 max-w-xs text-sm leading-relaxed text-[#566B63]">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
